import { useEffect, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Table from "../Table";
import { useNavigate, useParams, Link } from "react-router-dom";
import SelectDropdown from "../common/SelectDropdown";
import { Tooltip } from "antd";
import methodModel from "../../methods/methods";
import { FiPlus } from "react-icons/fi";
import AddAttendee from "../../Pages/Events/AddAttendee";
import rolesModel from "../../models/roles.model";
import { useSelector } from "react-redux";
import datepipeModel from "../../models/datepipemodel";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import "./style.scss";
import { toast } from "react-toastify";
import { encryptId } from "../common/Encryption/encryption";
import environment from "../../environment";

// cw: defined outside Members so React keeps a stable component reference (no flicker on re-render)
const ListHtml = ({ row, attend, SelectedAttendances, connectMeetLabel, canCheckIn, groupId }: any) => {
  const isChecked = SelectedAttendances.some((item: any) =>
    (item.email === row?.email || item.email === row?.memberDetails?.email));
  return (
    <>
      <ul className="w-[100%] sm:w-[49%] md:w-[33.33%] inline-block pr-2">
        <li className={`divide-y divide-gray-200 w-full  pb-2  `}>
          <div
            className={`main_innerss bg-white ${row.isPresent ? "bg-green-200 " : ""
              } rounded-md border border-neutral-300 p-4 h-full`}
          >
            <Link
              to={`/user-profile/${row?.userId || row?.memberDetails?._id}${groupId ? `?groupId=${groupId}` : ''}`}
              className="flex items-center space-x-4 rtl:space-x-reverse cursor-pointer rounded-md p-2 -m-2 transition-colors hover:bg-gray-100"
              onClick={(e) => {
                if (!row?.userId && !row?.memberDetails?._id) e.preventDefault();
              }}
            >
              <div className="flex-shrink-0 h-12 w-12">

                <img
                  src={methodModel.userImg(row?.memberDetails?.image)}
                  className="h-12 w-12 rounded-md mx-auto object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate dark:text-white capitalize">
                  {row.memberDetails?.fullName || row.fullName}{" "}
                  {row.memberDetails?.fullName ? "" : ""}
                  <p className="text-red-500">{row?.connectMeet == "not_interested" ? "Not Attending" : ""}</p>

                </p>
                <p className="text-xs min-h-[16px]"> {row?.type == "guest" ? "Guest" : row?.type && row?.type !== "Member" ? row.type : ""}</p>
                <p className="text-xs text-gray-500 truncate dark:text-gray-400">
                  {row.memberDetails?.email || row.email}
                </p>
              </div>
            </Link>
            <div className="border-t border-neutral-300 mt-3 pt-3">
              <div className="text-sm flex items-center justify-between mb-2">
                <p className="text-black font-medium"> RSVP'd </p>

                <p className="font-semibold">
                  {" "}
                  {row?.meetConfirm === "Yes" ? "Yes" : "No"}
                </p>
              </div>

              <div className="text-sm flex items-center justify-between mb-2">
                <p className="text-black font-medium"> Checked In </p>

                <p className="font-semibold">
                  {" "}
                  {row?.isPresent ? "Yes" : "No"}
                </p>

                <label className="switch">
                  <input
                    disabled={!canCheckIn || row?.connectMeet == "not_interested"}
                    checked={row.isPresent}
                    type="checkbox"
                    onChange={() => attend(row)}
                  />
                  <span className={`slider round ${!canCheckIn ? 'opacity-50 cursor-not-allowed' : ''}`}></span>
                </label>
              </div>

              <div className="text-sm flex items-center justify-between mb-2">
                <p className="text-black font-medium"> {connectMeetLabel} </p>

                <p className="font-semibold">
                  {" "}
                  {row?.connectMeet === "connect_with_members"
                    ? "Available"
                    : row?.connectMeet === "not_interested"
                      ? "Unavailable"
                      : row?.connectMeet === "system_generate"
                        ? "Available"
                        : "Available"}
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};

export default function Members({ eventDetail = "", eventId = "", getDetailApi }: any) {

  const [dataa, setDataa] = useState([]);
  const [isGroupGenerated, setIsGroupGenerated] = useState();
  const [data, setData] = useState([]);
  const [selectAllData ,setselectAllData] = useState([])
  const [loading, setLoader] = useState(false);
  const [total, setTotal] = useState(0);
  const [tab, setTab] = useState("list");
  const [role, setRole] = useState();
  const [selectedCount, setSelectedCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [SelectedAttendances, setSelectedAttendances]: any = useState([]);
  const user = useSelector((state: any) => state.user);
  const [filters, setFilter] = useState({
    page: 1,
    count: 10000, // show all attendees in RSVP List so select all actually selects all
    search: "",
    eventId: eventId,
    sortBy: "fullName asc", // sorts alphabetically by default
    key: "fullName",
    sorder: "asc",
  });
  const [searchTerm, setSearchTerm] = useState("");

  // cw: add in connectMeetLabel from event's group, fallback to user's group
  const connectMeetLabel = eventDetail?.groupId?.connectMeetLabel || user?.connectMeetLabel || 'ConnectMeet';

  const history = useNavigate();

  const canCheckIn = (() => {
    const eventGroupId = eventDetail?.groupId?._id || eventDetail?.groupId;
    if (!eventGroupId || !user?.groups) return false;
    const group = user.groups.find((g: any) => {
      const gid = g.groupId?._id || g.groupId;
      return gid === eventGroupId && g.status === 'active';
    });
    if (!group) return false;
    const roleId = group.customerRole?._id || group.customerRole;
    return environment.groupLeaderRoleIds.includes(roleId) || environment.connectmeetmanagerRoleId === roleId;
  })();

  const attendPremit = (row: any) => {
    let value = false;
    if (row?.addedBy === user._id || eventDetail?.addedBy === user._id)
      value = true;
    if (role == "meetManager" || role == "assistant") value = true;
    return value;
  };
  const getDetail = () => {
    loader(true);
    ApiClient.get("api/event/details", {
      id: eventId,
      email: user?.email,
    }).then((res) => {
      loader(false);
      if (res.success) {
        setData(res.data);
      }
    });
  };
  const deletePremit = (row: any) => {
    let value = false;
    if (row?.addedBy === user._id || eventDetail?.addedBy === user._id)
      value = true;
    if (role == "assistant") value = true;
    return value;
  };

  const columns = [
    {
      key: "fullName",
      name: "Name",
      render: (row: any) => {
        return <>{row?.memberDetails?.fullName}</>;
      },
    },
    {
      key: "email",
      name: "Email",
      render: (row: any) => {
        return <>{row?.memberDetails?.email}</>;
      },
    },
    {
      key: "isConnectedMeating",
      name: "Connect Meet",
      render: (row: any) => {
        return (
          <>
            <label
              className={`inline-flex items-center cursor-pointer ${attendPremit(row) ? "" : "opacity-50"
                }`}
            >
              <input
                type="checkbox"
                value=""
                className="sr-only peer"
                disabled={attendPremit(row) ? false : true}
                onChange={(e) => connectToggle(row)}
                checked={row.isConnectedMeating}
              />
              <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"></span>
            </label>
          </>
        );
      },
    },
    {
      key: "isPresent",
      name: "Present",
      render: (row: any) => {
        return (
          <>
            <label
              className={`inline-flex items-center cursor-pointer ${attendPremit(row) ? "" : "opacity-50"
                }`}
            >
              <input
                type="checkbox"
                value=""
                className="sr-only peer"
                disabled={attendPremit(row) ? false : true}
                onChange={(e) => attend(row)}
                checked={row.isPresent}
              />
              <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              <span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300"></span>
            </label>
          </>
        );
      },
    },
    {
      key: "role",
      name: "Role",
      render: (row: any) => {
        return (
          <>
            <SelectDropdown
              placeholder="Select Role"
              intialValue={row.attendeeRole}
              disabled={eventDetail?.addedBy === user._id ? false : true}
              options={rolesModel.list}
              result={(e: any) => {
                roleUpdate(row, e.value);
              }}
            />
          </>
        );
      },
    },
    {
      key: "action",
      name: "Action",
      render: (itm: any) => {
        return (
          <>
            <div className="flex items-center justify-start gap-1.5">

              {deletePremit(itm) ? (
                <>
                  <Tooltip placement="top" title="Delete">
                    {" "}
                    <span
                      onClick={() => deleteItem(itm.id)}
                      className="border cursor-pointer !border-[#E9253129] hover:opacity-70 rounded-lg bg-[#FDE9EA] w-10 h-10 text-[#E92531] flex items-center justify-center text-xl"
                    >
                      <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>
                    </span>{" "}
                  </Tooltip>
                </>
              ) : (
                <></>
              )}
            </div>
          </>
        );
      },
    },
  ];

  const connectToggle = (row: any) => {
    let isConnectedMeating = row.isConnectedMeating ? false : true;
    
    // cw: update UI immediately
    const updatedData = dataa.map((item: any) => 
      item.id === row.id ? { ...item, isConnectedMeating: isConnectedMeating } : item
    );
    setDataa(updatedData as never[]);
    
    // update backend without triggering full reload
    ApiClient.put("api/attendees/update", {
      id: row.id,
      isConnectedMeating: isConnectedMeating,
    });
  };

  const attend = (row: any) => {
    let isPresent = row.isPresent ? false : true;
    
    // cw: save scroll position before update (dont scroll back up after checking in ppl in RSVP List)
    const scrollContainer = document.querySelector('.modal.overflow-y-auto') || document.querySelector('.custom-scrollbar') || document.documentElement;
    const scrollPosition = scrollContainer?.scrollTop || 0;
    
    // cw: update the ui immediately - preserve sort order
    const updatedData = dataa.map((item: any) => 
        item.id === row.id ? { ...item, isPresent: isPresent } : item
    );
    // Use functional update to prevent scroll jump
    setDataa(() => updatedData as never[]);
    
    // Restore scroll position after React commits DOM update
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (scrollContainer) {
          scrollContainer.scrollTop = scrollPosition;
        }
      });
    });
    
    // update SelectedAttendances based on new state
    if (isPresent) {
      // adding to checked in - add to SelectedAttendances if not there
      const attendanceItem = {
          email: row.email || row.memberDetails?.email || "",
          odlUserId: row.odlUserId || row.userId || row.memberDetails?.odlUserId || "",
          eventId: eventDetail?._id || ""
      };
      
      if (!SelectedAttendances.some((item: any) => item.odlUserId === attendanceItem.odlUserId)) {
          const newSelected = [...SelectedAttendances, attendanceItem];
          setSelectedAttendances(newSelected);
          setSelectedCount(newSelected.length);
      }
  } else {
      // rmv from checked in - remove from SelectedAttendances
      const newSelected = SelectedAttendances.filter((item: any) => 
          item.odlUserId !== row.odlUserId && item.odlUserId !== row.userId && item.odlUserId !== row.memberDetails?.odlUserId
      );
      setSelectedAttendances(newSelected);
      setSelectedCount(newSelected.length);
  }
    
    // update backend without triggering full reload
    ApiClient.put("api/attendees/update", {
        id: row.id,
        isPresent: isPresent,
    });
  };
  {

  }
  const roleUpdate = (row: any, role: any) => {
    // cw: update UI immediately
    const updatedData = dataa.map((item: any) => 
      item.id === row.id ? { ...item, attendeeRole: role } : item
    );
    setDataa(updatedData as never[]);
    
    // update backend without triggering full reload
    ApiClient.put("api/attendees/update", {
      id: row.id,
      attendeeRole: role,
    });
  };
  const getData = (p = {}) => {
    let f = { ...filters, ...p };
    setLoader(true);

    // cw: debug - log to localStorage since console may be inaccessible during freeze
    const debugLog = (msg: string) => {
      const logs = JSON.parse(localStorage.getItem('checkinDebug') || '[]');
      logs.push(`${new Date().toISOString()} ${msg}`);
      if (logs.length > 50) logs.shift();
      localStorage.setItem('checkinDebug', JSON.stringify(logs));
    };

    debugLog('getData called');

    // cw: safety timeout - if loading takes more than 5s, force-hide loader and show retry
    const safetyTimer = setTimeout(() => {
      debugLog('SAFETY TIMEOUT - forcing loader off');
      setLoader(false);
      // also force-hide global loader in case it's stuck
      document.getElementById('loader')?.classList.add('d-none');
    }, 5000);

    ApiClient.get("api/attendees/list", f).then((res) => {
      clearTimeout(safetyTimer);
      debugLog(`getData response: success=${res.success} count=${res.data?.length || 0}`);
      if (res.success) {
        setIsGroupGenerated(res?.isGroupGenerated);
        // cw: sort alphabetically by name
        const sortedData = (res.data || []).sort((a: any, b: any) => {
          const nameA = (a.memberDetails?.fullName || a.fullName || '').toLowerCase();
          const nameB = (b.memberDetails?.fullName || b.fullName || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        setDataa(sortedData);
        setTotal(res.total);
      }
      setLoader(false);
    }).catch((err: any) => {
      clearTimeout(safetyTimer);
      debugLog(`getData ERROR: ${err}`);
      setLoader(false);
      document.getElementById('loader')?.classList.add('d-none');
    });
  };

  // filter data based on search term
  const filteredData = dataa.filter((row: any) => {
    if (!searchTerm) return true;
    const name = (row.memberDetails?.fullName || row.fullName || '').toLowerCase();
    const email = (row.email || row.memberDetails?.email || '').toLowerCase();
    const search = searchTerm.toLowerCase();
    return name.includes(search) || email.includes(search);
  });

  const getDataSelect = (p = {}) => {
    let payload={
      eventId: eventId,
    }
    // cw: don't call setLoader here — it races with getData and can hide loading prematurely
    ApiClient.get("api/attendees/list",payload).then((res) => {
      if (res.success) {
        setselectAllData(res?.data)
      }
    });
  };
  const getRole = () => {
    let f = {
      search: user.email,
      count: 1,
    };
    ApiClient.get("api/attendees/list", f).then((res) => {
      if (res.success) {
        let data = res.data?.[0];
        setRole(data?.attendeeRole || "member");
      }
    });
  };

  useEffect(() => {
    getData();
    getRole();
    // getDetail();
    // cw: removed getDetailApi() - it triggers the full-page loader overlay which freezes the UI
    // event details are already loaded by the parent EventDetail component
    getDataSelect()
  }, []);

  const pageChange = (e: any) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const sorting = (key: any) => {
    let sorder = "asc";
    if (filters.key == key) {
      if (filters.sorder == "asc") {
        sorder = "desc";
      } else {
        sorder = "asc";
      }
    }

    let sortBy = `${key} ${sorder}`;
    setFilter({ ...filters, sortBy, key, sorder });
    getData({ sortBy, key, sorder });
  };

  const clear = () => {
    let f = {
      search: "",
      page: 1,
    };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const deleteItem = (id: any) => {
    if (window.confirm("Do you want to delete this")) {
      loader(true);
      ApiClient.delete("api/attendees", { id: id }).then((res) => {
        if (res.success) {
          clear(); 
        }
        loader(false);
      });
    }
  };
  const handleOpenModal = async () => {
    //   history(`/groupsDetail/${eventDetail?._id}`);
    const id = eventDetail?._id;

    const stateData = {
      eventDetail: "",
      dataa: { data },
      eventId: { id },
      groupId:user?.groupId,
      attendeesGroup: "",
    };
    history(`/groupsDetail/${await encryptId(eventDetail?._id)}`, {
      state: stateData,
    });
  };
  // cw: sends Mark Attendance email (same as RSVP, no Yes/No buttons)
  // const markAttendance = () => {
  //   loader(true)
  //   ApiClient.post('api/sentEmail', { eventId: eventId }).then(res => {
  //     loader(false)
  //     if (res.success) {
  //       // toast.success(res.message)
  //       // getDetail()
  //       getDetailApi()
  //     }
  //   })
  // }

  const handleMarkAttedance = () => {
    ApiClient.post(`api/mark/attandance`, { data: SelectedAttendances }).then(
        (res) => {
            if (res.success) {
                toast.success(res?.message);
                setSelectedAttendances([]);
                setSelectedCount(0);
                // cw: rmved the markAttendance() call that causes loading page
            }
        }
    );
};
  // const [payload, setPayload] = useState([{ email: "", loginId: "", eventId: "" }])


  // cw: update totalCount when dataa changes (moved out of ListHtml to avoid hooks inside nested component)
  useEffect(() => {
    const totalPending = dataa.filter((row: any) => row.isPresent).length;
    setTotalCount(totalPending);
  }, [dataa]);

  const handleCheckboxChange = (row: any) => {
      const email = row.email === user?.email || row.type === "guest" ? row.email : row.memberDetails?.email || "";
      const odlUserId = row.odlUserId || row.userId || row.memberDetails?.odlUserId || "";
      const eventId = eventDetail?._id || "";

      let newSelectedAttendances = [...SelectedAttendances];
      const index = newSelectedAttendances.findIndex(item => item.odlUserId === odlUserId);

      if (index > -1) {
        newSelectedAttendances.splice(index, 1);
      } else {
        newSelectedAttendances.push({ email, odlUserId, eventId });
      }

      setSelectedAttendances(newSelectedAttendances);

      // Update selected count
      setSelectedCount(newSelectedAttendances.length);

      // // Calculate pending count
      // const totalPending = dataa.filter((row: any) => row.meetConfirm === "Yes" && !row.isPresent).length;
      // setTotalCount(totalPending);

      setSelectAll(newSelectedAttendances.length === dataa.length); // Update selectAll based on current selection
    };

    // const handleCheckboxChange = (row: any) => {

    //   const email =
    //     row?.email == user?.email || row?.type == "guest"
    //       ? row?.email
    //       : row.memberDetails?.email || "";
    //   const loginId: any =
    //     row?.email == user?.email
    //       ? row?.addedByDetail?.loginId
    //       : row.memberDetails?.loginId || "";
    //   const eventId = eventDetail?._id || "";
    //   let PreviousData: any = SelectedAttendances;
    //   const Indesx = PreviousData?.findIndex(
    //     (item: any) => item?.loginId == loginId
    //   );
    //   if (!Indesx) {
    //     PreviousData = PreviousData.filter(
    //       (item: any) => item?.loginId != loginId
    //     );
    //   } else {
    //     const Payload = { email, loginId, eventId };
    //     PreviousData.push(Payload);
    //   }

    //   setSelectedAttendances([...PreviousData]);
    // const itemIndex = payload.findIndex(item => item.email === email);

    // if (itemIndex > -1) {

    //     const newPayload = payload.filter(item => item.email !== email);
    //     setPayload([...newPayload]);
    // } else {

    //     const newPayload = [...payload];

    //     newPayload?.push( { email, loginId, eventId })
    //     setPayload([...newPayload]);
    //     console.log(newPayload , "newPayloadnewPayloadnewPayload")
    // }
    // };

    // const isChecked =
    //   SelectedAttendances.some(
    //     (item: any) => item.email == row?.email
    //   )

  const handleSelectAll = () => {
    // Use filteredData to select all visible items (respects search filter)
    const dataToProcess = filteredData;
    
    if (!selectAll) {
        // cw: select all eligible items and mark them as checked in (regardless of RSVP status)
        const eligibleRows = dataToProcess.filter((row: any) => 
            !row.isPresent && 
            row.connectMeet !== "not_interested"
        );
        
        // Update UI immediately
        const eligibleIds = new Set(eligibleRows.map((row: any) => row.id));
        const updatedData = dataa.map((item: any) => {
            return eligibleIds.has(item.id) ? { ...item, isPresent: true } : item;
        });
        setDataa(updatedData as never[]);
        
        // Build SelectedAttendances array so Mark Attendance is clickable
        const newSelectedAttendances = eligibleRows.map((row: any) => ({
          email: row.email || row.memberDetails?.email || "",
          odlUserId: row.odlUserId || row.userId || row.memberDetails?.odlUserId || "",
          eventId: eventDetail?._id || ""
      }));
        setSelectedAttendances(newSelectedAttendances);
        setSelectedCount(newSelectedAttendances.length);
        
        // Update backend for each item
        eligibleRows.forEach((row: any) => {
            ApiClient.put("api/attendees/update", {
                id: row.id,
                isPresent: true,
            });
        });
    } else {
        // Uncheck all that were checked (from filtered view)
        const checkedRows = dataToProcess.filter((row: any) => row.isPresent);
        const checkedIds = new Set(checkedRows.map((row: any) => row.id));
        
        // Update UI immediately
        const updatedData = dataa.map((item: any) => 
            checkedIds.has(item.id) ? { ...item, isPresent: false } : item
        );
        setDataa(updatedData as never[]);
        
        // Update backend
        checkedRows.forEach((row: any) => {
            ApiClient.put("api/attendees/update", {
                id: row.id,
                isPresent: false,
            });
        });
        
        // Clear selections
        setSelectedAttendances([]);
        setSelectedCount(0);
    }
    setSelectAll(!selectAll);
  };

  const pending = totalCount - selectedCount


  return (
    <>
      <div>
        {tab == "list" ? (
          <>
            {eventDetail?.addedBy == user._id ||
              role == "meetManager" ||
              role == "assistant" ? (
              <>
                <button
                  onClick={() => setTab("add")}
                  className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
                >
                  + Add Member
                </button>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <>
            <button
              onClick={() => {
                setTab("list");
              }}
              className="bg-primary leading-10 mr-3 h-10 flex items-center shadow-btn px-6 hover:opacity-80 text-sm text-white rounded-lg gap-2"
            >
              Back
            </button>
          </>
        )}
      </div>

      {tab == "add" ? (
        <>
          <AddAttendee
            eventId={eventId}
            eventDetail={eventDetail}
            result={(e: any) => {
              if (e.event == "submit") {
                clear();
                setTab("list");
              }
            }}
          />
        </>
      ) : (
        <>
          {loading ? (
            <>
              <div className="text-center">Loading...</div>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between gap-2 ">

                <div className="">
                  <h4 className="text-xl capitalize font-semibold">
                    {eventDetail?.title}
                  </h4>
                  <p className="text-md mt-1 font-medium text-black-800">
                  {datepipeModel.formatDateToTimezone(eventDetail?.date, eventDetail?.timezone)}
                  </p>
                
                </div>
                <div className="flex gap-4 items-center">
                  {/* <button
                    className="bg-primary text-white px-3 py-3 rounded-xl"
                    onClick={handleMarkAttedance}
                  >
                    Mark Attendance
                  </button> */}
                 
                  {/* <button
                    className={`bg-primary text-white px-3 py-3 rounded-xl ${SelectedAttendances.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                    onClick={handleMarkAttedance}
                    disabled={SelectedAttendances.length === 0} // Disable if no checkboxes are selected
                  >
                    Mark Attendance
                  </button> */}

                  {isGroupGenerated ? (
                    <div className="flex justify-end flex-grow">
                      <button
                        onClick={handleOpenModal}
                        className="bg-[#46454E] inline-flex  py-3 px-3 flex items-center justify-center gap-x-2 text-white shadow hover:shadow-lg rounded-xl"
                      >
                        <AiOutlineUsergroupAdd />
                        See All Groups
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              <div className="flex items-center justify-between gap-2 bg-gray-50 p-4 rounded-lg">
                  <div className="flex items-center gap-4">
                    <label className="flex cursor-pointer gap-0.5 items-center">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className=" h-4 w-4"
                      />
                      <span>Select All</span>
                    </label>
                    <span className="text-sm text-gray-500">
                      ({filteredData.length} attendees)
                    </span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="text"
                      placeholder="Search by name or email..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="px-3 py-2 border border-gray-300 rounded-lg text-sm w-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {searchTerm && (
                      <button
                        onClick={() => setSearchTerm("")}
                        className="ml-2 text-gray-500 hover:text-gray-700"
                      >
                        ✕
                      </button>
                    )}
                  </div>
              </div>

              <Table
                data={filteredData}
                columns={columns as any}
                page={1}
                count={filteredData.length}
                total={filteredData.length}
                theme="list"
                ListHtml={ListHtml}
                listHtmlProps={{ attend, SelectedAttendances, connectMeetLabel, canCheckIn, groupId: eventDetail?.groupId?._id || eventDetail?.groupId }}
                result={(e) => {
                  if (e.event == "sort") sorting(e.value);
                }}
              />
            </>
          )}
        </>
      )}
    </>
  );
}
